// Deploy-skew safe: falls back to the legacy uber flag when the API
// doesn't send marketplace_source yet.
export const isMarketplaceOrder = (order) => (
  !!(order && (order.marketplace_source || order.is_uber_eats_order))
);
